import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { OrderItemAttributes } from "@models/orderItem.model";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
    selector: "app-return-exchange-success",
    templateUrl: "./return-exchange-success.component.html",
    styleUrl: "./return-exchange-success.component.scss",
    standalone: false,
})
export class ReturnExchangeSuccessComponent implements OnInit {
    public items: OrderItemAttributes[] = [];
    public totalAmount: number = 0;
    public orderID: any;
    public action!: string;

    constructor(
        private location: Location,
        private router: Router,
        private route: ActivatedRoute,
    ) {}

    ngOnInit(): void {
        this.route.params.subscribe((params) => {
            (this.orderID = params["id"]), (this.action = params["action"]);
        });

        this.items = history.state.seletedItems;
        this.totalAmount = history.state.total;
    }

    public goBack(): void {
        this.location.back();
    }

    public goToOrderDetail() {
        this.router.navigate([`/account/orders/${this.orderID}/orderInfo`]);
    }

    public goToTrack() {
        this.router.navigate([`/account/trackOrder`]);
    }

    public goToHome() {
        this.router.navigate([`/home`]);
    }
}
